import { BaseTextMergeContainerEditor } from "../Text/BaseTextMergeContainerEditor";
import { TextIcon } from "../../../CommonUI/TextIcon";
import { BaseTextMergeContainerElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeContainerElement";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";
import { Box } from "@mui/material";
import { BaseTextMergeElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import React from "react";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { TextEditorRegistration } from "../../Utilities/RegisterTextEditor";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { JSONXMLBuildObjectElement } from "../../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLBuildObjectElement";
import { TextMergeType } from "../../../rule-engine-core/TextMerge/TextMergeType";
import { XMLAttributeEditor } from "./XMLAttributeEditor";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";
import { InlineTextEdit } from "../../../CommonUI/InlineEditor/InlineTextEdit";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

export class JSONXMLBuildObjectEditor extends BaseTextMergeContainerEditor<JSONXMLBuildObjectElement> {
    getIcon(): JSX.Element {
        return <TextIcon name={"{...}"} />;
    }

    override renderAbove(
        _element: BaseTextMergeContainerElement,
        _context: TextMergeEditContext,
    ): JSX.Element | undefined {
        return (
            <Box
                marginLeft={"30px"}
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"start"}
                paddingBottom={"10px"}
            >
                <UILabel>Name: </UILabel>
                <InlineTextEdit
                    text={this.editorData!.fieldName ?? ""}
                    onEdit={(v) => {
                        this.editorData!.fieldName = v;
                    }}
                />
            </Box>
        );
    }

    renderDisplay(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        let styles = this.editorData?.getStyles();
        return (
            <ObserveState
                listenTo={this.editorData}
                control={() => {
                    return this.renderContent(editContext, styles?.styleObject ?? {});
                }}
            />
        );
    }

    renderContent(editContext: TextMergeEditContext, _styles: object): React.ReactNode {
        if (editContext.definition.type === TextMergeType.XML) {
            return XMLAttributeEditor.renderXMLContainer(this.editorData!, editContext, this.editorData!.fieldName);
        } else {
            // JSON
            let begin = "{";
            let end = "}";
            return (
                <>
                    <span
                        style={
                            editContext.selectedElement?.id === this.editorData!.id
                                ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                                : {}
                        }
                        onClick={() => {
                            editContext.setSelectedElement(this.editorData!);
                        }}
                    >
                        {DataUtilities.getIndent(this.editorData!.getDepth())}"
                        {this.editorData!.fieldName + '" : ' + begin}
                    </span>
                    <br />
                    {this.editorData?.elements.map((e) => {
                        let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
                        return (
                            <ObserveState
                                key={e.id}
                                listenTo={e}
                                control={() => {
                                    return editor?.renderDisplay(e, editContext);
                                }}
                            />
                        );
                    })}
                    <span
                        style={
                            editContext.selectedElement?.id === this.editorData!.id
                                ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                                : {}
                        }
                        onClick={() => {
                            editContext.setSelectedElement(this.editorData!);
                        }}
                    >
                        {DataUtilities.getIndent(this.editorData!.getDepth())}
                        {end}
                    </span>
                    <br />
                </>
            );
        }
    }
}
